import React from 'react';
import { Link } from 'react-router-dom';
import { getSortedNews, newsCategoryStyle, formatNewsDate } from '../data/news';

const Cover = ({ item, className }) => {
    if (item.cover) {
        return (
            <img
                src={item.cover}
                alt={item.title}
                loading="lazy"
                decoding="async"
                className={className}
            />
        );
    }
    return (
        <div className={`${className} bg-gradient-to-br from-slate-400 to-blue-600 flex items-center justify-center`}>
            <span className="text-white/90 text-4xl" aria-hidden>
                {item.category === '团队活动' ? '🏀' : '📰'}
            </span>
        </div>
    );
};

const News = () => {
    const latest = getSortedNews().slice(0, 3);

    return (
        <div id="news" className="bg-white py-16 md:py-24">
            <section>
                <div className="container mx-auto px-4 md:px-8">
                    <div className="text-center mb-14 md:mb-16">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
                            <span className="text-2xl">📰</span>
                        </div>
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">新闻动态</h2>
                        <div className="w-20 h-1 bg-blue-600 mx-auto mb-6 rounded-full"></div>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                            产品进展、公司动态与团队活动
                        </p>
                    </div>

                    {latest.length === 0 ? (
                        <div className="max-w-4xl mx-auto text-center py-16 bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl border border-dashed border-gray-300">
                            <p className="text-gray-500 text-lg font-medium">动态即将上线</p>
                            <p className="text-gray-400 text-sm mt-2">敬请期待族语的最新资讯</p>
                        </div>
                    ) : (
                        <>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
                                {latest.map((item) => {
                                    const { full } = formatNewsDate(item.date);
                                    return (
                                        <Link
                                            key={item.slug}
                                            to={`/news/${item.slug}`}
                                            className="group bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col"
                                        >
                                            <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                                                <Cover
                                                    item={item}
                                                    className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                                                />
                                            </div>
                                            <div className="p-6 flex flex-col flex-1">
                                                <div className="flex items-center gap-3 mb-3">
                                                    <span className={`text-xs font-medium px-2.5 py-0.5 rounded-full ${newsCategoryStyle[item.category] || 'bg-gray-100 text-gray-600'}`}>
                                                        {item.category}
                                                    </span>
                                                    <time className="text-xs text-gray-400">{full}</time>
                                                </div>
                                                <h3 className="text-lg font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-300 leading-snug mb-2">
                                                    {item.title}
                                                </h3>
                                                <p className="text-sm text-gray-500 leading-relaxed line-clamp-2 flex-1">
                                                    {item.summary}
                                                </p>
                                                <span className="mt-4 text-sm font-medium text-blue-600 inline-flex items-center gap-1">
                                                    阅读全文
                                                    <svg className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                                    </svg>
                                                </span>
                                            </div>
                                        </Link>
                                    );
                                })}
                            </div>
                            <div className="text-center mt-12">
                                <Link
                                    to="/news"
                                    className="inline-flex items-center justify-center px-8 py-3 rounded-xl border-2 border-blue-600 text-blue-700 hover:bg-blue-50 font-medium transition-colors duration-300"
                                >
                                    查看全部资讯
                                </Link>
                            </div>
                        </>
                    )}
                </div>
            </section>
        </div>
    );
};

export default News;
